module.exports = __webpack_public_path__ + "img/section2Locationm.55c5c974.png";